import React from 'react';

// A row of buttons of which one is on: the DS segmented toggle (.ds-seg, Css/Input.css), which the Bool input renders
// as Yes / No. For two or three short, mutually exclusive choices. `options` is [{ value, label }]; the button whose
// value equals `value` is on, and none is when nothing matches (a cleared Bool, for example).
export default function SegmentedToggle({ options = [], value = null, onChange = (newValue) => {}, className = '' }) {
  return (
    <div
      className={('ds-seg ' + className).trim()}
      role='group'
    >
      {options.map((option) => (
        <button
          key={String(option.value)}
          type='button'
          className={option.value === value ? 'on' : ''}
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
